module.exports = __webpack_public_path__ + "7d65cd36735f9b56cfbc4969e64926df.svg";